import React, { createContext, useState, useMemo, useContext, useCallback } from 'react';
import { dataMaintenanceService } from '../services/DataMaintenanceService';

export const DataMaintenanceContext = createContext();

export const DataMaintenanceProvider = props => {
    const [dataInspector] = useState([]);
    const [weatherStations, setWeatherStations] = useState([]);
    
    const getWeatherStations = useCallback(async () => {
        const result = await dataMaintenanceService.getAllWeatherStations();
        setWeatherStations(result);
    }, []);

    const postDataMaintenance = useCallback(async (query) => {
        const result = await dataMaintenanceService.postDataMaintenance(query);
        return result;
    }, []);

    const deleteFunctionData = useCallback(async (body) => {
        const result = await dataMaintenanceService.deleteFunctionData(body);
        return result;
    }, []);

    const calculateFunctions = useCallback(async (body) => {
        const result = await dataMaintenanceService.calculateFunctions(body);
        return result;
    }, []);

    const getElasticTask = useCallback(async (taskId) => {
        const result = await dataMaintenanceService.getElasticTask(taskId);
        return result;
    }, []);

    const patchWeatherData = useCallback(async (body) => {
        const result = await dataMaintenanceService.patchWeatherData(body);
        return result;
    }, []);

    const patchNumericPointData = useCallback(async (body) => {
        const result = await dataMaintenanceService.patchNumericPointData(body);
        return result;
    }, []);
 
    const values = useMemo(
        () => ({
            weatherStations,
            dataInspector,
            getWeatherStations,
            postDataMaintenance,
            deleteFunctionData,
            calculateFunctions,
            getElasticTask,
            patchWeatherData,
            patchNumericPointData
        }),
        [
            weatherStations,
            dataInspector,
            getWeatherStations,
            postDataMaintenance,
            deleteFunctionData,
            calculateFunctions,
            getElasticTask,
            patchWeatherData,
            patchNumericPointData
        ]
    );

    return <DataMaintenanceContext.Provider value={values}>{props.children}</DataMaintenanceContext.Provider>;
};

export const useDataMaintenance = () => {
    
    const context = useContext(DataMaintenanceContext);

    if (context === undefined) {
        throw new Error('useDataMaintenance must be used within a DataMaintenanceProvider component.');
    } 

    return context;
};
